import SearchFormField from 'components/SearchV2/Components/SearchFormField/SearchFormField'
import { GlobalSearchStateContext } from 'contexts/GlobalSearch/GlobalSearchContexts'
import React, { useContext, useMemo } from 'react'
import { CruiseDurationOptions } from './CruiseWhenHowLong'
import { take } from 'lib/arrayUtils'

interface Props extends Omit<React.ComponentProps<typeof SearchFormField>, 'label' | 'placeholder' | 'value'> {
}

function CruiseWhenField(props: Props, ref) {
  const { ...rest } = props

  const { flexibleMonths, durationMax, durationMin } = useContext(GlobalSearchStateContext)

  const inputValue = useMemo(() => {
    const departureMonths = flexibleMonths?.split(',').filter(Boolean) ?? []

    const option = CruiseDurationOptions.find(opt => opt.min >= durationMin && opt.max <= durationMax)
    const limitVisible = option ? 1 : 3
    const more = departureMonths.length > limitVisible ? `+${departureMonths.length - limitVisible}` : ''
    const dates = take(departureMonths.map((d) => {
      const [year, month] = d.split('-')
      return `${month}/${year}`
    }), limitVisible)

    const dateValues = dates.length && `${dates.join(', ')} ${more}`
    return [dateValues, option?.name].filter(Boolean).join(' | ')
  }, [durationMax, durationMin, flexibleMonths])

  return <SearchFormField
    {...rest}
    ref={ref}
    label="When"
    placeholder="Anytime"
    value={inputValue}
  />
}

export default React.forwardRef<HTMLButtonElement, Props>(CruiseWhenField)
